import moment from 'jalali-moment';
import { LogData } from '../components/interfaces';

export const gapForDay = (logs: LogData[], interval: number) => {

  if (logs.length === 0) {
    return logs;
  }

  const firstDate = moment.from(logs[0]._id, 'en');
  const start = firstDate.clone().startOf('day');
  const end = firstDate.clone().endOf('day');

  const result = [];
  let current = start;

  while (!current.isAfter(end)) {
    const isoTime = current.toISOString();
    const found = logs.find(x => x._id === isoTime) as any;
    if (found) {
      result.push({
        _id: isoTime,
        avg: (found.DC_Percent <= 50 && found.CDC_Percent <= 50) ? found.avg : undefined,
        DC_Percent: found.DC_Percent,
        CDC_Percent: found.CDC_Percent
      });
    }
    else {
      result.push({
        _id: current.clone().toISOString(),
        avg: undefined,
        DC_Percent: undefined,
        CDC_Percent: undefined
      });
    }
    current = current.add(interval, 'minutes');
  }

  return result;
}

export const gapForMonth = (logs: LogData[], interval: number) => {
  const disconnects = [];
  if (logs.length === 0) {
    return logs;
  }

  const before = [];

  let current: moment.Moment;
  // fix server bug if returns one day from past month
  const log1 = moment.from(logs[0]._id, 'en');
  if (logs.length > 1) {
    const log2 = moment.from(logs[1]._id, 'en');
    current = log1.format('jMM') === log2.format('jMM') ? log1 : log1;
  }
  else {
    current = log1;
  }

  const start = current.clone().startOf('month');
  const end = current.clone().endOf('month');

  while(start.isBefore(current.subtract(interval, 'minutes'))) {
    before.push({
      _id: current.toISOString(),
      avg: undefined,
      DC_Percent: -1,
      CDC_Percent: -1,
    })
  }

  logs = [...before.reverse(), ...logs];

  current = moment.from(logs[0]._id, 'en');
  while (!current.isAfter(end)) {
    const isoTime = current.toISOString();
    const found = logs.find(x => x._id === isoTime) as any;
    if (found) {
      if (found.DC_Percent >= 50 || found.CDC_Percent >= 50) {
        disconnects.push({ _id: found._id, avg: found.avg });
        current = current.add(interval, 'minutes');
        continue;
      }
    }
    else {
      logs.push({
        _id: current.clone().toISOString(),
        avg: undefined,
        DC_Percent: undefined,
        CDC_Percent: undefined,
        isEmpty: true
      });
    }
    current = current.add(interval, 'minutes');
  }

  return logs;
}
